<template>
  <el-cascader
    ref="select"
    style="width:100%;"
    :expand-trigger="trigger"
    popper-class="vxe-table--ignore-clear"
    :options="citysOptions"
    :filterable="filterable"
    :props="{ expandTrigger: expandTrigger }"
    v-model="addressId"
    @change="select"
    clearable
    :placeholder="placeholder"
    :disabled="disabled"
  ></el-cascader>
</template>

<script>
export default {
  name: 'ab-address',
  model: {
    modelValue: String
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Array
    },
    filterable: {
      type: Boolean,
      default: true
    },
    expandTrigger: {
      type: String,
      default: 'hover'
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    addressData: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data () {
    return {
      addressId: this.modelValue,
      citysOptions: this.addressData
    }
  },
  mounted () {
    if (!this.citysOptions.length) {
      let option = this.$utils.getSessionStorage('cityData')
      if (!option || !option.length) {
        this.$initSessionStorageData.getCityData().then(result => {
          this.citysOptions = this.$utils.getSessionStorage('cityData')
        })
      } else {
        this.citysOptions = option
      }
    }
  },
  watch: {
    addressData (value) {
      this.citysOptions = value
    },
    address (value) {
      if (value && typeof value != 'object') {
        let temp = []
        value.split(',').map(e => {
          temp.push(e + '')
        })
       this.modelValue = temp
       console.log(this.address)
      }
    },
    modelValue(val){
        this.addressId = val
    }
  },
  methods: {
    select (nodes) {
      this.$emit('update:modelValue', this.addressId)
      /* this.$emit('change', nodes, this.$refs.select.getCheckedNodes()[0].text)
      this.$emit('handleSelect', nodes, this.$refs.select.getCheckedNodes()[0].text) */
      let text = this.$refs.select.getCheckedNodes()[0] ? this.$refs.select.getCheckedNodes()[0].text : ''
      this.$emit('change', nodes, text)
      this.$emit('handleSelect', nodes, text)
    },
    getAddressData () {
      return this.$post('/bas/basArea/list', { isEnabled: 1 })
        .then(({ data }) => {
          if (data && data.code === 'C0000') {
            return data.result
          } else {
            this.$message({
              type: 'error',
              message: data.message,
              grouping: true,
              offset: 380
            })
            return []
          }
        }).catch(err => {
          console.error(err)
          this.$message({
              type: 'error',
              message: '服务器正忙，暂时无法获取地址数据',
              offset: 380,
              grouping: true,
            })
          return []
        })
    }
  }
}
</script>

<style lang="scss">
  .el-cascader.is-disabled .el-cascader__label {
    color: #666;
  }
</style>
